import HundredBricksAPIError from '../HundredBricksAPIError';
class SendInactiveAccountError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('SendInactiveAccountError', ...args);
    }
}
export default SendInactiveAccountError;
